import React, { FC, InputHTMLAttributes, useState } from 'react';

import cn from 'classnames';

import Icon from '../../icon/icon';

import EyeCrossedSvg from '../images/eye-crossed.svg';
import EyeSvg from '../images/eye.svg';
import InfoSvg from '../images/info.svg';

import css from './OutlinedInput.css';

interface OutlinedInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
}

const OutlinedInput: FC<OutlinedInputProps> = ({
    type = 'text',
    placeholder = '',
    label,
    error,
    className,
    ...inputProps
}) => {
    const [inputType, setInputType] = useState<
        InputHTMLAttributes<HTMLInputElement>['type']
    >(type);

    const toggleShowPassword = () => {
        setInputType((prevState) =>
            prevState === 'text' ? 'password' : 'text',
        );
    };

    return (
        <div
            className={cn(css.container, className, {
                [css.error]: error,
            })}
        >
            <input
                className={css.input}
                type={inputType}
                placeholder={placeholder}
                data-type={type}
                {...inputProps}
            />
            <label className={css.label} htmlFor={inputProps.id}>
                {label}
            </label>
            {type === 'password' && (
                <span
                    className={css.showPasswordIcon}
                    onClick={toggleShowPassword}
                >
                    <Icon
                        glyph={inputType === 'text' ? EyeCrossedSvg : EyeSvg}
                    />
                </span>
            )}
            {type === 'text' && (
                <Icon className={css.infoIcon} glyph={InfoSvg} />
            )}
            {error && <span className={css.errorMessage}>{error}</span>}
        </div>
    );
};

export default OutlinedInput;
